"use client";

// RingWatch — mounted once in the dashboard: keeps the private ring's asks
// current (useRingWatch, a quiet poll), so a new request counts beside the
// inbox tab and says so once in the corner wherever you are. Renders nothing.

import { useRingWatch } from "./useInbox";

export default function RingWatch({ enabled }: { enabled: boolean }) {
  useRingWatch(enabled);
  return null;
}
